import * as React from 'react';
import {
  List,
  Datagrid,
  Edit,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  EditButton,
  ShowButton,
  TextInput,
  BooleanField,
  BooleanInput,
  DateField,
  useTranslate,
} from 'react-admin';

import EmptyList from '../components/misc/EmptyList';

const entity = 'adApplications';

export const AdApplicationList = (props) => {
  const translate = useTranslate();
  return (
    <List
      {...props}
      empty={<EmptyList entity={entity} />}
      title={translate('adApplications.title', { _: 'Reklam Başvuruları' })}
      exporter={false}
      sort={{ field: 'createdate', order: 'DESC' }}
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField source="name" label={translate('users.name', { _: 'Ad Soyad' })} />
        <TextField source="email" label={translate('saleAgents.email', { _: 'E-posta' })} />
        <TextField source="phone" label={translate('promoters.mobile', { _: 'Telefon' })} />
        <TextField
          source="companyName"
          label={translate('adApplications.company', { _: 'Şirket' })}
        />
        <TextField
          source="packageName"
          label={translate('adApplications.package', { _: 'Paket' })}
        />
        <TextField
          source="packageType"
          label={translate('adApplications.package_type', { _: 'Paket Tipi' })}
        />
        <BooleanField
          source="isChecked"
          label={translate('affiliateForm.checked', { _: 'İncelendi mi?' })}
        />
        <DateField source="createdate" label={translate('common.date', { _: 'Tarih' })} showTime />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export const AdApplicationShow = (props) => {
  const translate = useTranslate();
  return (
    <Show title={translate('adApplications.detail', { _: 'Reklam Başvurusu' })} {...props}>
      <SimpleShowLayout>
        <BooleanField
          source="isChecked"
          label={translate('affiliateForm.checked', { _: 'İncelendi mi?' })}
        />
        <TextField source="name" label={translate('users.name', { _: 'Ad Soyad' })} />
        <TextField source="email" label={translate('saleAgents.email', { _: 'E-posta' })} />
        <TextField source="phone" label={translate('promoters.mobile', { _: 'Telefon' })} />
        <TextField
          source="companyName"
          label={translate('adApplications.company', { _: 'Şirket' })}
        />
        <TextField source="website" label="Website" />
        <TextField
          source="packageName"
          label={translate('adApplications.package', { _: 'Paket' })}
        />
        <TextField
          source="packageType"
          label={translate('adApplications.package_type', { _: 'Paket Tipi' })}
        />
        <TextField source="packageId" label="Package ID" />
        <TextField
          source="preferredStart"
          label={translate('adApplications.preferred_start', { _: 'Tercih Edilen Başlangıç' })}
        />
        <TextField source="budget" label={translate('adApplications.budget', { _: 'Bütçe' })} />
        <TextField source="message" label={translate('adApplications.message', { _: 'Mesaj' })} />
        <DateField source="createdate" label={translate('common.date', { _: 'Tarih' })} showTime />
      </SimpleShowLayout>
    </Show>
  );
};

export const AdApplicationEdit = (props) => {
  const translate = useTranslate();
  return (
    <Edit title={translate('adApplications.review', { _: 'Başvuruyu İncele' })} {...props}>
      <SimpleForm redirect={`/${entity}`}>
        <h2>{translate('affiliateForm.actions', { _: 'İşlemler' })}</h2>
        <BooleanInput
          source="isChecked"
          label={translate('affiliateForm.checked', { _: 'İncelendi mi?' })}
        />
        <TextInput
          source="notes"
          label={translate('affiliateForm.notes', { _: 'Notlar' })}
          fullWidth
          multiline
          rows={3}
        />

        <h2>{translate('affiliateForm.details', { _: 'Başvuru Detayları' })}</h2>
        <TextInput
          source="name"
          label={translate('users.name', { _: 'Ad Soyad' })}
          fullWidth
          disabled
        />
        <TextInput
          source="email"
          label={translate('saleAgents.email', { _: 'E-posta' })}
          fullWidth
          disabled
        />
        <TextInput
          source="phone"
          label={translate('promoters.mobile', { _: 'Telefon' })}
          fullWidth
          disabled
        />
        <TextInput
          source="companyName"
          label={translate('adApplications.company', { _: 'Şirket' })}
          fullWidth
          disabled
        />
        <TextInput source="website" label="Website" fullWidth disabled />
        <TextInput
          source="packageName"
          label={translate('adApplications.package', { _: 'Paket' })}
          fullWidth
          disabled
        />
        <TextInput
          source="packageType"
          label={translate('adApplications.package_type', { _: 'Paket Tipi' })}
          fullWidth
          disabled
        />
        <TextInput source="packageId" label="Package ID" fullWidth disabled />
        <TextInput
          source="preferredStart"
          label={translate('adApplications.preferred_start', { _: 'Tercih Edilen Başlangıç' })}
          fullWidth
          disabled
        />
        <TextInput
          source="budget"
          label={translate('adApplications.budget', { _: 'Bütçe' })}
          fullWidth
          disabled
        />
        <TextInput
          source="message"
          label={translate('adApplications.message', { _: 'Mesaj' })}
          fullWidth
          multiline
          rows={4}
          disabled
        />
      </SimpleForm>
    </Edit>
  );
};
